import type { Ref } from 'vue';
import type { ExtendedPartTagType } from '@/entities/rubrics';
import { useI18n } from '@experience/i18n';
import ru from '@/widgets/rubricsBlock/i18n/ru.json';
import { allValue, moreValue } from '@/widgets/rubricsBlock/tour';

export function useTourRegionVisibleTags(
  rubricsAdapters: Ref<ExtendedPartTagType[]>,
  selectedValue: Ref<ExtendedPartTagType>,
  isMobile: Ref<boolean>,
) {
  const { t } = useI18n({
    inheritLocale: true,
    messages: {
      ru,
    },
  });

  const setMobileTagsOrder = (rubric: ExtendedPartTagType) => {
    if (rubric.value === allValue) {
      return [...rubricsAdapters.value];
    }

    const filteredRubricAdapters = rubricsAdapters.value.filter((tag) => tag.value !== rubric.value);

    return filteredRubricAdapters.length < 3
      ? [filteredRubricAdapters[0], rubric, ...filteredRubricAdapters.slice(1)]
      : [filteredRubricAdapters[0], filteredRubricAdapters[1], rubric, ...filteredRubricAdapters.slice(2)];
  };

  const visibleTags = computed(() => {
    if (selectedValue.value.value === moreValue) {
      return [];
    }

    const isHasCurrentTag = rubricsAdapters.value.some((item) => item.value === selectedValue.value.value);
    const desktopAppearance = isHasCurrentTag ? rubricsAdapters.value : [...rubricsAdapters.value, selectedValue.value];

    return isMobile.value
      ? setMobileTagsOrder(selectedValue.value)
      : [...desktopAppearance, { label: t('rubrics_section.more'), value: moreValue }];
  });

  return { visibleTags };
}
